import { mapActions, mapState } from 'vuex';
import appMainNav from '@/components/app/app-main-nav/app-main-nav.vue';
import unreadNotificationMixin from '@/mixins/unreadNotification';
import notificationsWidget from '@/components/notifications-widget/notifications-widget.vue';
import hamburgerIcon from '@/components/hamburger-icon/hamburger-icon.vue';
import headerNavMixin from '@/mixins/headerNav';


export default {
  mixins: [
    headerNavMixin,
    unreadNotificationMixin,
  ],
  components: {
    appMainNav,
    hamburgerIcon,
    notificationsWidget,
  },
  computed: {
    ...mapState('app', ['mobileMenuOpened']),
    ...mapState('notifications', ['showNotificationsWidget']),
    isNotificationsWidgetDisabled() {
      return (this.$route && this.$route.name === 'dashboard-notifications') || this.mobileMenuOpened;
    },
    isNotificationIconActive() {
      return this.$route.name === 'notifications' || this.showNotificationsWidget;
    },
    showUnreadNotificationCount() {
      return !this.isNotificationIconActive && this.userUnreadNotificationsCountHeader > 0;
    },
    notificationsIconModifiers() {
      return {
        'app-header__notifications': true,
        'app-header__notifications--disabled': this.isNotificationsWidgetDisabled,
        'app-header__notifications--unread': this.showUnreadNotificationCount,
        'app-header__notifications--active': this.isNotificationIconActive,
      };
    },
    depositClassModifiers() {
      const disabled = this.$route.name === 'wallet';
      return {
        'app-header__menu-item': true,
        'app-header__menu-item--deposit': true,
        'app-header__menu-item--disabled': disabled,
      };
    },
  },
  watch: {
    $route() {
      this.closeNotificationsWidget();
    },
    showNotificationsWidget(value) {
      if (!value) {
        this.clearAllNotifications();
      }
    },
  },
  methods: {
    ...mapActions('notifications', ['toggleNotificationsWidget', 'closeNotificationsWidget']),
    ...mapActions('search', ['toggleSearchBar', 'closeSearchBar']),
    onNotificationsClick() {
      if (!this.isNotificationsWidgetDisabled) {
        this.toggleNotificationsWidget();
        this.closeSearchBar();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header/app-header.js